/* default prefix RELATED_CARDS_ */
export const AT_INIT = 'RELATED_CARDS_INIT';
export const AT_CARD_DELETE = 'RELATED_CARDS_CARD_DELETE';
export const AT_CARD_ADD = 'RELATED_CARDS_CARD_ADD';
